// Extend the type, and declare the new function
interface Date {
  to12PM(): Date;
  addHours(hours: number): Date;
}

// Return an immutate Date Obj
Date.prototype.to12PM = function () {
  let self: Date = this;
  const copied = new Date(self.getTime());
  copied.setHours(12);
  return copied;
};

Date.prototype.addHours = function (hours: number) {
  let self: Date = this;
  const copied = new Date(self.getTime());
  copied.setTime(copied.getTime() + hours * 60 * 60 * 1000);
  return copied;
};
